import styled from '@emotion/styled';

import { Paragraph } from '@/components/common/MarkUp';
import { Stack } from '@/components/layout/Stack';

import type { SidePanel } from '@/sanity/sanity.types';

export interface KeyStatsProps {
  keyStats: SidePanel['keyStats'];
}

export const KeyStats = ({ keyStats }: KeyStatsProps) => {
  return (
    <Stack spacing="--space-component-lg">
      {keyStats?.map((stat) => {
        return (
          <Stack key={stat._key} spacing="--space-component-xs">
            <StatNumber size="heading-lg">{stat.number}</StatNumber>
            <StatDescription size="body-md">{stat.description}</StatDescription>
          </Stack>
        );
      })}
    </Stack>
  );
};

const StatNumber = styled(Paragraph)`
  color: var(--text-galaxy);
`;
const StatDescription = styled(Paragraph)`
  color: var(--text-strong);
`;
